import React, { useState } from 'react';
import style from '../css/Login.module.css';
import logo from '../images/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function Login() {
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [showPassword, setShowPassword] = useState(true);
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);

	const handleLogin = async () => {
		setLoading(true);
		setError('');

		if (!email || !password) {
			setError('Please enter both email and password');
			setLoading(false);
			return;
		}

		try {
			const res = await axios.post(
				'https://hometech-repairs.in/customerDB/login.php',
				{ email, password }
			);

			if (res.data.status) {
				setError(res.data.msg);
				localStorage.setItem('user', JSON.stringify(res.data.data));
				console.log(res.data.data);

				navigate('/dashboard');
				setLoading(false);
			} else {
				setError(res.data.msg);
				setLoading(false);
			}
		} catch (err) {
			console.error(err);
			setError('Login failed');
			setLoading(false);
		}
	};

	return (
		<div className={style.main}>
			<div className={style.container}>
				{/* <h1 className={style.text}> HomeTech</h1> */}
				<h1 className={style.text1}> Login Here</h1>
				<p>Welcome back!</p>
				<div style={{ margin: 10 }} />
				<input
					type="text"
					placeholder="E-mail ID"
					value={email}
					onChange={(e) => {
						setEmail(e.target.value);
						setError('');
					}}
					className={style.input}
				/>

				<div className={style.pass}>
					<input
						placeholder="Password"
						value={password}
						type={showPassword == false ? 'text' : 'password'}
						onChange={(e) => {
							setPassword(e.target.value);
							setError('');
						}}
						className={style.passinput}
					/>
					{showPassword == false ? (
						<div
							className={style.eye}
							onClick={() => setShowPassword(!showPassword)}
						>
							<FaEye className={style.eyeIcon} />
						</div>
					) : (
						<div
							className={style.eye}
							onClick={() => setShowPassword(!showPassword)}
						>
							<FaEyeSlash className={style.eyeIcon} />
						</div>
					)}
				</div>

				<Link to="/reset" className={style.forgotPassword}>
					forgot password?
				</Link>
				<Link className={style.button} onClick={handleLogin}>
					{loading ? 'Loading...' : 'Login'}
				</Link>
				<div style={{ margin: 10 }} />

				<Link to="/register" className={style.register}>
					Create an account
				</Link>

				<p style={{ color: 'gray' }}>{error}</p>

				{/* <Link to="https://hometech-repairs.in/" className={style.skip}>
					Back to home
				</Link> */}
			</div>
			{/* <img src={logo} alt="" className={style.img} /> */}
		</div>
	);
}

export default Login;
